import { getListPageMaxHeight } from '../../../styles/sxStyling';
import { appZIndex } from '../../../styles/zIndex';

// Event Map Styles
export const eventMapContainerStyles = {
  borderRadius: 4,
};

export const mapWrapperStyles = {
  position: 'relative',
  height: getListPageMaxHeight(),
  width: '100%',
  overflow: 'hidden',
  borderRadius: 3,
};

export const errorMessageStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  gap: 1,
};

export const mapStyles = {
  width: '100%',
  height: '100%',
};

export const loadingOverlayStyles = (transparent = false) => ({
  position: 'absolute',
  inset: 0,
  zIndex: appZIndex.sticky,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  bgcolor: transparent ? 'rgba(255,255,255,0.55)' : 'background.paper',
  ...(transparent && {
    backdropFilter: 'blur(2px)',
  }),
});

// Event Map Tile Styles
export const eventMapTileContainerStyles = {
  display: 'flex',
  flexDirection: 'row',
  minWidth: 320,
  maxWidth: 420,
  p: 1,
  backgroundColor: 'background.paper',
  overflow: 'hidden',
};

export const eventMapTileSectionStyles = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 0.75,
};
export const eventMapTileHeaderSectionStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  minWidth: 0,
};

export const eventMapTileHeaderStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontWeight: 500,
  fontSize: '1rem',
};

export const eventMapTileTextContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.45,
};

export const eventMapTileSecondaryStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  minWidth: 0,
  width: '100%',
};

export const eventMapTileSecondaryIconStyles = {
  fontSize: '1.1rem',
  color: 'text.secondary',
  mt: '2px',
  flexShrink: 0,
};

export const eventMapTileSecondaryLabelStyles = {
  fontSize: '0.85rem',
  color: 'text.secondary',
  lineHeight: 1.4,
  flex: 1,
  minWidth: 0,
  whiteSpace: 'normal',
  overflowWrap: 'anywhere',
  wordBreak: 'break-word',
};
